function resolve(specificationOrCheckFn) {
    if (typeof specificationOrCheckFn == "function") {
        return spec(specificationOrCheckFn);
    }
    // eslint-disable-next-line no-use-before-define
    return specificationOrCheckFn;
}

export function spec(specificationOrCheckFn) {
    return {
        // eslint-disable-next-line id-length
        is: (candidate) => typeof specificationOrCheckFn === 'function'
            ? specificationOrCheckFn(candidate)
            : specificationOrCheckFn.is(candidate),

        and(specificationOrCheckFn) {
            return spec((candidate) => this.is(candidate) && resolve(specificationOrCheckFn).is(candidate));
        },

        // eslint-disable-next-line id-length
        or(specificationOrCheckFn) {
            return spec((candidate) => this.is(candidate) || resolve(specificationOrCheckFn).is(candidate));
        },

        not() {
            return spec((candidate) => !this.is(candidate));
        }
    };
};
